import React, { FC } from 'react';
import { IIconProps } from 'app/components/svgs/Icon';

const Users: FC<IIconProps> = ({ fill = '#000000', size = '100%', width = size, height = size, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 18 16" preserveAspectRatio="xMidYMid meet" {...props}>
    <path
      fill={fill}
      d="M12 12.041v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485
0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6
1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z"
    />
    <path
      fill={fill}
      d="M5.112 12.427c0.864-0.565 1.939-0.994
3.122-1.256-0.235-0.278-0.449-0.588-0.633-0.922-0.475-0.863-0.726-1.813-0.726-2.748 0-1.344
0-2.614 0.478-3.653 0.464-1.008 1.299-1.633 2.488-1.867-0.264-1.195-0.968-1.98-2.841-1.98-3
0-3 2.015-3 4.5 0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h4.359c0.227-0.202
0.478-0.393 0.753-0.573z"
    />
  </svg>
);

export default Users;
